/* aaa-collapsible-text.js
   Companion to blocks/aaa-collapsible-text.liquid.
   Handles the Read more / Show less toggle plus auto-skip when content
   is short enough not to need clamping.

   Init points:
   - DOMContentLoaded (or immediately if document is already parsed)
   - shopify:section:load    (theme editor adds/edits a section)
   - shopify:block:select    (theme editor selects this block — auto-expand
                              so merchant can see what they're editing)
   - window.load             (re-measure once images inside the rich text
                              have loaded, in case they shifted height)
*/

(function () {
  var INIT_FLAG = 'collapsibleTextInit';

  function setup(wrapper) {
    if (!wrapper || wrapper.dataset[INIT_FLAG] === 'true') return;

    var content = wrapper.querySelector('.aaa-collapsible-text__content');
    var toggle = wrapper.querySelector('[data-collapsible-text-toggle]');
    if (!content || !toggle) return;

    var clampedHeight = parseInt(
      getComputedStyle(wrapper).getPropertyValue('--aaa-collapsible-text-max-height'),
      10
    ) || 280;
    var skipThreshold = parseFloat(wrapper.dataset.skipThreshold) || 1.3;

    /* Measure natural height by temporarily lifting the clamp.
       The wrapper's data-collapsed gates the CSS clamp, so flip it,
       read scrollHeight, then restore. */
    var wasCollapsed = wrapper.dataset.collapsed === 'true';
    wrapper.dataset.collapsed = 'false';
    var naturalHeight = content.scrollHeight;
    wrapper.dataset.collapsed = wasCollapsed ? 'true' : 'false';

    if (naturalHeight < clampedHeight * skipThreshold) {
      // Content is short — no clamp, no toggle.
      wrapper.dataset.collapsed = 'false';
      wrapper.dataset.collapsibleTextSkipped = 'true';
      toggle.hidden = true;
    } else {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var collapsed = wrapper.dataset.collapsed === 'true';
        wrapper.dataset.collapsed = collapsed ? 'false' : 'true';
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');

        // If the user just collapsed an expanded block while scrolled past it,
        // pull them back so they don't lose their place in the page.
        if (!collapsed) {
          var rect = wrapper.getBoundingClientRect();
          if (rect.top < 0) {
            window.scrollTo({
              top: window.scrollY + rect.top - 80,
              behavior: 'smooth'
            });
          }
        }
      });
    }

    wrapper.dataset[INIT_FLAG] = 'true';
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-collapsible-text]').forEach(setup);
  }

  // Re-measure but keep init flag (in case images loaded late and changed height)
  function remeasure() {
    document.querySelectorAll('[data-collapsible-text]').forEach(function (wrapper) {
      // Only re-measure if not yet skipped — once skipped we're done.
      if (wrapper.dataset.collapsibleTextSkipped === 'true') return;
      var content = wrapper.querySelector('.aaa-collapsible-text__content');
      var toggle = wrapper.querySelector('[data-collapsible-text-toggle]');
      if (!content || !toggle) return;

      var clampedHeight = parseInt(
        getComputedStyle(wrapper).getPropertyValue('--aaa-collapsible-text-max-height'),
        10
      ) || 280;
      var skipThreshold = parseFloat(wrapper.dataset.skipThreshold) || 1.3;

      var wasCollapsed = wrapper.dataset.collapsed === 'true';
      wrapper.dataset.collapsed = 'false';
      var naturalHeight = content.scrollHeight;
      wrapper.dataset.collapsed = wasCollapsed ? 'true' : 'false';

      if (naturalHeight < clampedHeight * skipThreshold) {
        wrapper.dataset.collapsed = 'false';
        wrapper.dataset.collapsibleTextSkipped = 'true';
        toggle.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', remeasure);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var wrapper = e.target.closest && e.target.closest('[data-collapsible-text]');
    if (!wrapper) return;
    if (wrapper.dataset.collapsed === 'true') {
      wrapper.dataset.collapsed = 'false';
      var toggle = wrapper.querySelector('[data-collapsible-text-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
  });
})();
